<style>
    body, html {
        width: 100%;
        height: 100%;
        min-width: 1000px;
        font-family: PingFangSC-Regular;
    }
    #app {
        height: 100%;
        min-width: 1000px;
        position: relative;
    }
    header {
        width: 100%;
        height: 100px;
        padding-bottom: 15px!important;
        background: rgba(255,255,255,0) url('//d.fenfenriji.com/pink/static_v1/images/topbar.png')!important;
        background-size: auto 100%!important;
        position: relative;
        z-index: 99999999;
    }

    header .headerInner {
        width: 70%;
        height: 40px;
        padding-top: 15px;
        padding-bottom: 15px;
        margin: 0 auto;
        min-width: 800px;
    }

    .logo {
        display: block;
        height: 40px;
        float: left;
        cursor: pointer;
    }

    .headerNav {
        height: 40px;
        float: right;
    }

    .headerNav li {
        float: left;
        height: 14px;
        line-height: 14px;
        font-size: 16px;
        color: #999;
        letter-spacing: 0;
        padding-right: 15px;
        padding-left: 15px;
        margin-top: 12px;
        margin-bottom: 12px;
        cursor: pointer;
    }
    header .lis ~ .lis {
        border-left: 1px solid #999999;
    }
    .wxgzh .wxewm {
        display: none;
    }
    .wxgzh:hover .wxewm {
        display: block;
        z-index: 9999999;
    }
    .footerAll {
        position: absolute;
        width:100%;
        height: 60px;
        left:0;
        bottom:0;
        color: #999999;
        background-color: #fff;
    }
</style>
<template>
    <div id="app">
        <header style="padding-bottom: 15px;">
            <div class="headerInner clearfix">
                <div class="fl" style="text-indent: -999999px">
                    粉粉日记 粉粉日记官方网站
                    <img @click="goRouter({path: '/index'})" :src="imgHost + 'slogan.png'" alt="" class="logo" style="background-color:#fff;">
                </div>
                <ul class="headerNav clearfix">
                    <router-link  @click.native="chooseNav('index')" ref="index" to="/index" tag="li" class="lis">首页</router-link>
                    <router-link  @click.native="chooseNav('joinUs')" ref="joinUs" to="/joinUs" tag="li" class="lis">加入我们</router-link>
                    <router-link  @click.native="chooseNav('privacy')" ref="privacy" to="/privacy" tag="li" class="lis">粉粉协议</router-link>
                    <router-link  @click.native="chooseNav('help')" ref="help" to="/help" tag="li" class="lis">帮助</router-link>
                    <li class="wxgzh" style="position:relative;">
                        <a href="javascript:;" title="粉粉日记微信公众号"><img :src="imgHost + 'wechat.png'" alt=""></a>
                        <div class="wxewm" style="position:absolute;left: -55px;top: 0px;padding-top: 15px;">
                            <img :src="imgHost + 'wxgzh.png'" alt="" style="display: block;width: 160px;">
                        </div>
                    </li>
                    <li>
                        <a @click="openWindow('https://weibo.com/xxtstudio')" href="javascript:;" title="粉粉日记新浪微博"><img :src="imgHost + 'microblog.png'" alt=""></a>
                    </li>
                </ul>
            </div>
        </header>
        <router-view style="margin-top: -48px;width:100%;background-image: linear-gradient(-180deg, #B2DDF9 0%, #E3F2F9 100%);"></router-view>
    </div>
</template>
<script>
    import './assets/css/reset.css'
    import './assets/css/main.css'
    export default {
        name: 'app',
        data () {
            return {
            }
        },
        methods: {
            chooseNav: function (route) {
                this.$nextTick(() => {
                    this.$refs['index'].$el.style.color = "#999"
                    this.$refs['joinUs'].$el.style.color = "#999"
                    this.$refs['help'].$el.style.color = "#999"
                    this.$refs['privacy'].$el.style.color = "#999"
                    this.$refs[route].$el.style.color = "#FF6EA4"
                })
            }
        },
        created: function () {
            this.$nextTick(() => {
                let doms = {
                    index: this.$refs['index'],
                    joinUs: this.$refs['joinUs'],
                    help: this.$refs['help'],
                    privacy: this.$refs['privacy'],
                }
                this.$store.commit('changeRouteDom', doms)
            })
//            this.$nextTick(() => {
//                let route = this.$route.name
//                console.log('route', route)
//                console.log(this.$refs)
//                if (this.$refs[route]) {
//                    this.$refs['index'].$el.style.color = "#999"
//                    this.$refs['joinUs'].$el.style.color = "#999"
//                    this.$refs['vip'].$el.style.color = "#999"
//                    this.$refs['help'].$el.style.color = "#999"
//                    this.$refs[route].$el.style.color = "#FF6EA4"
//                }
//            })
        }
    }
</script>



// WEBPACK FOOTER //
// src/App.vue